import * as React from "react";
import Manage from "../../assets/icons/star-fill.svg";
import Icon from "./Icon";

const FavoritesIcon = () => {
    var smallStyle = {
        height: 18,
        margin: "0px 8px 0px 0px" 
    }; 

  return (
    <React.Fragment>
          <Icon icon={Manage} text="Favorite" id="favoritesIcon" style={smallStyle} tooltip={true}/>
    </React.Fragment>
  );
};

export default FavoritesIcon;
